import { IMAGE_LOADER, ImageLoaderConfig } from '@angular/common';

export const queryImageLoader = (config: ImageLoaderConfig) => {
  const [path, existingQuery] = config.src.split('?');
  const params = new URLSearchParams(existingQuery || '');

  if (config.width) {
    params.set('w', config.width.toString());
  }

  if (config.loaderParams) {
    Object.entries(config.loaderParams).forEach(([key, value]) => {
      params.set(key, String(value));
    });
  }

  const queryString = params.toString();

  return queryString ? `${path}?${queryString}` : path;
};

export function providerQueryImageLoader() {
  return [
    {
      provide: IMAGE_LOADER,
      useValue: queryImageLoader,
    },
  ];
}
